import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'  // 导入store
import api, { debounceApi } from './api'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import moment from 'moment'; // 时间处理
Vue.prototype.$moment = moment;

// goeasy IM：单例在 src/utils/goeasy.js 中创建，这里挂载到原型供组件调用
import { goEasy } from './utils/goeasy';
Vue.prototype.goeasy = goEasy;
// 兼容之前用 this.$goEasy 调用的情况
Vue.prototype.$goEasy = goEasy;


Vue.config.productionTip = false

// 将API挂载到Vue原型上，方便组件中使用
Vue.prototype.$api = api
// 将防抖API挂载到Vue原型上，方便组件中使用
Vue.prototype.$dapi = debounceApi
Vue.use(ElementUI);
new Vue({
  router,
  store,  // 使用store
  render: h => h(App),
}).$mount('#app')